import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext'; // Import your Auth context to get the token

const AllOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth(); // Get the token from AuthContext

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/orders/allOrders`, {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in headers
          },
        });
        setOrders(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [token]);

  const handleStatusChange = async (orderId, newStatus) => {
    try {
      // Send the PUT request to the backend
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/orders/${orderId}/status`, {
        status: newStatus,
      }, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the auth token
        },
      });

      // Update the local state after the successful update
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order._id === orderId ? { ...order, status: newStatus } : order
        )
      );
    } catch (err) {
      setError(err.message);
    }
  };


  if (loading) return <p>Loading orders...</p>;
  if (error) return <p>Error fetching orders: {error}</p>;

  return (
    <div className="overflow-x-auto">
      <h1 className="text-2xl font-bold mb-4">All Orders</h1>
      <table className="min-w-full border border-gray-300 table-auto">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">Order #ID</th>
            <th className="border border-gray-300 px-4 py-2">Backup Code 1</th>
            <th className="border border-gray-300 px-4 py-2">Backup Code 2</th>
            <th className="border border-gray-300 px-4 py-2">Contact Email</th>
            <th className="border border-gray-300 px-4 py-2">Discount Code</th>
            <th className="border border-gray-300 px-4 py-2">Order Type</th>
            <th className="border border-gray-300 px-4 py-2">EA Email</th>
            <th className="border border-gray-300 px-4 py-2">EA Password</th>
            <th className="border border-gray-300 px-4 py-2">Status</th>
            <th className="border border-gray-300 px-4 py-2">Price</th>
            <th className="border border-gray-300 px-4 py-2">Quantity</th>
            <th className="border border-gray-300 px-4 py-2">Type</th>
            <th className="border border-gray-300 px-4 py-2">Cashback</th>

          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order._id} className="hover:bg-gray-50">
              <td className="border border-gray-300 px-4 py-2">{order.orderId}</td>
              <td className="border border-gray-300 px-4 py-2">{order.backupCode1}</td>
              <td className="border border-gray-300 px-4 py-2">{order.backupCode2}</td>
              <td className="border border-gray-300 px-4 py-2">{order.contactEmail}</td>
              <td className="border border-gray-300 px-4 py-2">{order.discountCode}</td>
              <td className="border border-gray-300 px-4 py-2">{order.orderType}</td>
              <td className="border border-gray-300 px-4 py-2">{order.originEmail}</td>
              <td className="border border-gray-300 px-4 py-2">{order.originPassword}</td>
              <td className="border border-gray-300 px-4 py-2">
                <select
                  value={order.status}
                  onChange={(e) => handleStatusChange(order._id, e.target.value)}
                  className="border border-gray-300 p-1"
                >
                  <option value="Pending">Pending</option>
                  <option value="Completed">Completed</option>
                  {/* Add more statuses if needed */}
                </select>
              </td>
              <td className="border border-gray-300 px-4 py-2">{order.price}</td>
              <td className="border border-gray-300 px-4 py-2">{order.quantity}</td>
              <td className="border border-gray-300 px-4 py-2">{order.type}</td>
              <td className="border border-gray-300 px-4 py-2">{order.cashBack}</td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

};

export default AllOrders;
